import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container, Hidden } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import TextField from '@material-ui/core/TextField';
import {authConfig} from '../auth/config';
import Cardconsulta from './cardConsulta';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import {Link} from 'react-router-dom';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';//em transito
import EventAvailableIcon from '@material-ui/icons/EventAvailable';//deferidas
import EventBusyIcon from '@material-ui/icons/EventBusy';//inderefiras
import EventNoteIcon from '@material-ui/icons/EventNote';//analise
import EventIcon from '@material-ui/icons/Event';//concluidas
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Unidadetransporte from '../componentes/unidadetransporterelatorio';
import Centroadministrativo from "../componentes/centroadministrativorelatorio";
import Unidadedepartamento from '../componentes/unidadedepartamentorelatorio';
import { Impressaorelatorioveiculos } from '../util/Impressaorelatorioveiculos';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   menuButton: {
    //marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    
  },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''



export const  Consultas = withRouter(({history}) => {
   
  
  //**************************************************** */

  const visualizarImpressao = (listav) => {
    
  //var rel = Impressaosolicitacao(props)
    //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
    //rel.criarpdf();
   console.log(listav);
   var qtd = listav.length;
   //console.log(statelista);
      const classeImpressaov = new Impressaorelatorioveiculos(listav,dataini,datafim,qtd);
      const documentov = classeImpressaov.GerarDocumento();
      pdfMake.createPdf(documentov).open({}, window.open('', '_blank'));
    
    
  }
  //firebase.firestore.Timestamp.fromDate(new Date(datahorasaida))
  const [statelista, setalista]=React.useState([]);
  var lista=[];
  async function handlegerarelatorio (){
    if((dataini!='')&&(datafim!='')){
    
        if(state.checkedunidade){
          if (unidade!='') {
            var db = firebase.firestore();
            //console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
            var query = await db.collection("veiculos").where('codunidadetransporte','==',unidade.id)
            .get().then(function(querySnapshot) {
              var tamanho= querySnapshot.size;
              var listam=[];
                        querySnapshot.forEach(function(doc) {
                          listam.push({id:doc.id, placa:doc.data().placa, modelo:doc.data().modelo,kmatual:doc.data().km,
                            ano:doc.data().ano, marca:doc.data().marca, npassageiros:doc.data().npassageiros,
                            
                          })
                        })
  
                        console.log(listam);
                        console.log(listam);
                        handlepegadesloc(listam);
  
                      }).catch(error => {
                        console.log(error);
                      });
  
          } else {
            alert("Selecione uma Unidade de Transporte")
          }
        }else{
            if(state.checkedplaca){

            
        }else{
          //só por data
          var db = firebase.firestore();
          //console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
          var query = await db.collection("veiculos")
          .get().then(function(querySnapshot) {
            var tamanho= querySnapshot.size;
            var listam=[];
                      querySnapshot.forEach(function(doc) {
                        listam.push({id:doc.id, placa:doc.data().placa, modelo:doc.data().modelo,kmatual:doc.data().km,
                          ano:doc.data().ano, marca:doc.data().marca, npassageiros:doc.data().npassageiros,
                          
                        })
                      })

                      console.log(listam);
                      console.log(listam);
                      handlepegadesloc(listam);

                    }).catch(error => {
                      console.log(error);
                    });

        }
      
      }
  }else{
    alert("Selecione as datas de inicio e fim do relatório")
  }
  }

  //******************pegadeslocamentos */

  async function handlepegadesloc(listam){
    var listamot=[];
    var listadespmotora=[];
    for (let index = 0; index < listam.length; index++) {
      listadespmotora=[];
        var kmtotalrodado=0;
        var kmf=0;
            var db1 = firebase.firestore();
            var query4 =  await db1.collection("agenda").where("status",'==',"concluido").where("datahorasaida",">=", firebase.firestore.Timestamp.fromDate(new Date(dataini))).where("datahorasaida","<=", firebase.firestore.Timestamp.fromDate(new Date(datafim)))
            .where("veiculo.id",'==',listam[index].id)
            .get().then(function(querySnapshot) {
              
                querySnapshot.forEach(function(doc2) {
                  var kmi=doc2.data().kminicio;
                  kmf = doc2.data().kmfinal;
                  var kmt = kmf-kmi;
                  kmtotalrodado = kmtotalrodado+ kmt;
                  listadespmotora.push({iddesloc:doc2.id,deslocamento: doc2.data().nsolicitacao, data:new Date(doc2.data().datahorasaida.seconds*1000).toLocaleString("pt-BR"),
                  kmrodado: kmt, kminicio: kmi, kmfinal:kmf, ocorrencias:'',motorista:doc2.data().motorista.label
                  });
  
                  //********** */
                })
                
  
  
              }).catch(error => {
                 console.log(error);
               });
               var kmt= listam[index].kmatual;
               if(kmf!=0){
                 kmt=kmf;

               }
               listamot.push({ id:listam[index].id, placa:listam[index].placa, modelo:listam[index].modelo,
                ano:listam[index].ano,marca:listam[index].marca, npassageiros:listam[index].npassageiros,
                kmatual:kmt, kmrodadototal: kmtotalrodado, deslocs:listadespmotora});
  
                console.log(listamot);
                console.log(listamot);
      
    }
  
    console.log("oiiii");
    handlepegadespesas(listamot);
  
  }

  //******************************pega ocorrencias */

  async function handlepegadespesas(listamot){
    var totalgeralpago=0;
    var totalgeralfaturado=0;
    var ocorrencias = []
    for (let index = 0; index < listamot.length; index++) {
      var totalpago=0;
        var totalfaturado=0;
      for (let index2 = 0; index2 < listamot[index].deslocs.length; index2++) {
        //listamot[index].deslocs[index2].valorpagomotorista='aíiiiiiiiiii'
        console.log(listamot[index].deslocs[index2]);
        console.log("oi");
  
        var db3 = firebase.firestore();
        var query3 = await db3.collection("agenda").doc(listamot[index].deslocs[index2].iddesloc).collection("obschecklist").get()
        .then(function(querySnapshot) {
              ocorrencias=[]
          querySnapshot.forEach(function(doc3) {

            ocorrencias.push({obs:doc3.data().obs})
        
                                                             
       
        
                                                      
                                          
          })
          
          listamot[index].deslocs[index2].ocorrencias=ocorrencias;
        //if(tamanho==ands){
        // visualizarImpressao(lista);
        //  }
        }).catch(error => {
        console.log(error);
        });
  
  
      }
            
    }
    console.log(listamot);
    console.log('listamot');
    //chamar a impressão do relátorio
    visualizarImpressao(listamot);
  }
  //*****************************************************controle botões solicitações */
  const [unidade, setaunidade] = React.useState('');
  const [nucleo, setanucleo] = React.useState('');
  const [departamento, setadepartamento] = React.useState('');

  //************************** */
  const [state, setState] = React.useState({
    
    checkeddepartamento: false, checkedplaca: false, checkedunidade: false,
  });
  


const handleCheck = (event) => {
  setState({ ...state, [event.target.name]: event.target.checked });
  
};

const [dataini, setadataini] = React.useState('');

  const [datafim, setadatafim] = React.useState('');

   //*****************************************************controle botões solicitações */
  //*****************************************************controle botões solicitações */
  function handlerelmotoristas(){
    history.push('/Relatoriomotoristas');  

}
function handlerelfaturamento(){
  history.push('/Relatoriofaturamento');  

}
 
function handlerelviagens(){
  history.push('/Relatorios');  
}

function handlereldeferidas(){
  history.push('/Relatoriodeferidas');  
}

function handlerelanalise(){
  history.push('/Relatorioanalise');  
}

function handlerrelveiculos(){
  history.push('/Relatorioveiculos');  
}
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      <br></br>
      <Container align='center'>
          <Grid container align="center">
          
          <Grid item xs>
            <Button        
                      variant="contained"
                      color="secondary"
                      startIcon={<EventNoteIcon />}
                      className={classes.submit}
                      onClick={handlerelviagens}
                      
                    >
                     Rel. de Viagens
                    </Button>
                  
            </Grid>
          
          <Grid item>
            <Button
        variant="contained"
        color="secondary"
        startIcon={<EventAvailableIcon />}
        onClick={handlerelanalise}
        className={classes.menuButton}
      >
       Rel. Análise
      </Button>
            
  </Grid>

  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<DepartureBoardIcon />}
            className={classes.submit}
            onClick={handlereldeferidas}
            
          >
             Rel. Deferidas
          </Button>
         
  </Grid>
  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<DirectionsCarIcon />}
            className={classes.submit}
            onClick={handlerrelveiculos}
            
          >
            Rel. Veículos
          </Button>
  </Grid>
  
  

 
  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<AssignmentIndIcon />}
            className={classes.submit}
            onClick={handlerelmotoristas}
            
          >
            Rel. Motoristas
          </Button>
  </Grid>

  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<AssignmentIndIcon />}
            className={classes.submit}
            onClick={handlerelfaturamento}
            
          >
            Rel. Faturamento
          </Button>
  </Grid>


          </Grid>
          </Container>
      <br></br>
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Relatório de Veículos
          </Typography>
          <Container maxWidth="xs">
         
      <div id="corpo"   align="center" className={classes.paper} >

         <div id="corpoveiculo">
         <br></br>
      <br></br>
         <TextField
      fullWidth
      required
      onChange={ e=>setadataini(e.target.value)}
      variant="outlined"
        id="datetimeini"
        label="Data Inicial do relatório"
        type="date"
        value={dataini}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}      
      />
      <br></br>
      <br></br>

<TextField
      fullWidth
      required
     onChange={ e=>setadatafim(e.target.value)}
      variant="outlined"
        id="datetimefim"
        label="Data Final do relatório"
        type="date"
        value={datafim}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}      
      />



      <FormGroup>
<FormControlLabel
        control={
          <Checkbox
          required
            checked={state.checkedunidade}
            onChange={handleCheck}
            name="checkedunidade"
            color="primary"
          />
        }
       
        label ="Filtrar por Unidade de Transporte "
        
        
      />

</FormGroup>
<div id="uni" hidden={!state.checkedunidade} >
<Unidadetransporte unidade={unidade} setaunidade={setaunidade}/>
</div>

<FormGroup>
<FormControlLabel
        control={
          <Checkbox
          required
            checked={state.checkedplaca}
            onChange={handleCheck}
            name="checkedplaca"
            color="primary"
          />
        }
       
        label ="Filtrar por Placa do veículo "
        
        
      />

</FormGroup>
<div id="uni" hidden={!state.checkedplaca} >
{//<Unidadetransporte unidade={unidade} setaunidade={setaunidade}/>

}
Digite a placa
</div>

<Button onClick={handlegerarelatorio} color="primary">
            Gerar
          </Button>
           </div>
          
          
      </div>
      </Container>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Consultas;
